var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";

var _default = (_temp2 = _class = function (_React$Component) {
  _inherits(_default, _React$Component);

  function _default() {
    var _temp, _this, _ret;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      triggerable: true
    }, _this.handleScroll = throttle(function (e) {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var triggerY = _this.props.offset;

      // offsets of below 1 are interpreted as percentage values
      if (triggerY > 0 && triggerY <= 1) {
        triggerY = document.documentElement.scrollHeight * triggerY;
      }

      // trigger when popping up at bottom of screen instead of top
      if (_this.props.bottom) {
        triggerY = triggerY - document.documentElement.clientHeight;
      }

      if (_this.state.triggerable && scrollY >= triggerY) {
        // trigger handler if scrolling below the threshold
        _this.setState({ triggerable: false });
        _this.props.onPass();
      } else if (!_this.props.once && !_this.state.triggerable && scrollY < triggerY) {
        // reset triggerable state if scrolling above the threshold again
        _this.setState({ triggerable: true });
        _this.props.onReverse();
      }
    }, 100), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _default.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  };

  _default.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  };

  _default.prototype.render = function render() {
    return null;
  };

  return _default;
}(React.Component), _class.propTypes = {
  offset: PropTypes.number.isRequired,
  bottom: PropTypes.bool,
  onPass: PropTypes.func,
  onReverse: PropTypes.func,
  once: PropTypes.bool
}, _class.defaultProps = {
  onPass: function onPass() {},
  onReverse: function onReverse() {},
  bottom: false,
  once: false
}, _temp2);

export { _default as default };